import { Stack } from "@mui/material";
import SponsorContent from "../../Account/components/SponsorContent";

export default function Sponsor(){
    return (
        <Stack sx={{ maxWidth: 800, margin: 'auto', py: 2 }}>
            <SponsorContent />
        </Stack>
    );
}